import { render, staticRenderFns } from "./ImageSpecialCoinPreview.vue?vue&type=template&id=e6bf60ba&scoped=true&"
import script from "./ImageSpecialCoinPreview.vue?vue&type=script&lang=ts&"
export * from "./ImageSpecialCoinPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSpecialCoinPreview.vue?vue&type=style&index=0&id=e6bf60ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bf60ba",
  null
  
)

export default component.exports